"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiDarkTheme = void 0;
const material_1 = require("@mui/material");
exports.muiDarkTheme = (0, material_1.createTheme)({
    palette: {
        mode: 'dark',
    },
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    // it fixes time picker spacing
                    width: '100% !important',
                },
            },
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        MuiPickersDay: {
            styleOverrides: {
                dayWithMargin: {
                    // this disables weird spaces for hidden days
                    margin: '0px !important',
                },
            },
        },
    },
});
